import { useEffect, useState } from 'react';

export const useWindowWidth = () => {
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  function handleResize() {
    setWindowSize(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
};

export default useWindowWidth;
